import { Checkbox, Stack, TableCell, TableHead, TableRow } from '@mui/material';
import React, { memo } from 'react';
import PropTypes from 'prop-types';

function TransactionTableHead({ handleSelectAll, disabled, checked }) {
  return (
    <TableHead>
      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
        <TableCell sx={{ width: { xs: '150px', sm: '15%' }, minWidth: '120px', fontWeight: 600 }}>
          <Stack direction="row" alignItems="center">
            <Checkbox sx={{ p: 0, mr: 1 }} disabled={disabled} checked={checked} onChange={handleSelectAll} />
            Date
          </Stack>
        </TableCell>
        <TableCell sx={{ width: { xs: '200px', sm: '20%' }, minWidth: '150px', fontWeight: 600 }}>
          Vendor
        </TableCell>
        <TableCell sx={{ width: { xs: '120px', sm: '12%' }, minWidth: '100px', fontWeight: 600 }}>
          Amount
        </TableCell>
        <TableCell sx={{ width: { xs: '250px', sm: '35%' }, minWidth: '200px', fontWeight: 600 }}>
          Memo
        </TableCell>
        <TableCell sx={{ width: { xs: '150px', sm: '18%' }, minWidth: '120px', pr: 3.5, fontWeight: 600 }} align="right">
          Actions
        </TableCell>
      </TableRow>
    </TableHead>
  );
}
TransactionTableHead.propTypes = {
  handleSelectAll: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
};

export default memo(TransactionTableHead);
